import gql from "graphql-tag"

export const SURVEY_AREA_DETAIL_FRAG = gql`
  fragment SurveyAreaDetailFrag on SurveyAreaLocationType {
    id
    type
    properties {
      name
      primaryUser {
        id
        fullName
        number
      }
      codename
      updatedAt
      distributionCentre {
        id
        name
        colorCode
        geometry {
          type
          coordinates
        }
      }
      users {
        id
        name: fullName
        number
      }
    }
    geometry {
      type
      coordinates
    }
  }
`
